import { Button, Input, Typography, notification } from 'antd';
import { useState, default as React } from 'react';
import { FetchFromBackend, ErrorConnectionFailed } from '../../shared/HelperContactBackend';

import '../../styles/Stepper.css';
import validator from 'validator';
import md5 from 'md5';
const { Text } = Typography;
const { Search } = Input;

export const PickerPlatform = ({ next, payingParticipants, setPlatform, setSessionId, setEmailIdentifier, useMobileVersion }) => {

    // Used seperately because of the asynchronous nature of hooks.
    const [emailIdentifierLocal, setEmailIdentifierLocal] = useState("");
    const [numDonations, setNumberDonations] = useState(null);
    
    // Expects a string
    function onClick(platform) {
        console.log("Platform = " + platform);

        setPlatform(platform);
        setEmailIdentifier(emailIdentifierLocal);

        const url = `session_ids/resolve?email_md5=${encodeURIComponent(md5(emailIdentifierLocal))}&platform=${encodeURIComponent(platform)}`;

        FetchFromBackend(
            url,
            () => {}, // don't advance here
            ErrorConnectionFailed,
            (resp) => {
                // Normalize the response so the rest of the app can always do sessionId.session_id
                const sid = resp?.session_id ?? resp;
                setSessionId({ session_id: sid });

                next();
            }
        );
    }


    const openDonationExists = () => {
        notification["error"]({
            message: <Text strong>{'Donation with this email exists'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"We already received a donation for this specific email. Please specify another email."}</Text>
                </div>,
        });
    };

    const openDonationsFulfilled = () => {
        notification["error"]({
            message: <Text strong>{'Enough donations received'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"We already received enough donations for this round of data collection."}</Text>
                </div>,
        });
    };
    
    const openNotificationEmailSet = (email) => {
        notification["success"]({
            message: <Text strong>{'Email Succesfully Set!'}</Text>,
            description:
                "Your email (" + email+ ") has been successfully set!",
        });
    };
    
    const openEmailRejected = (email) => {
        notification["error"]({
            message: <Text strong>{'Error when setting your email!'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"The provided email is not valid.\n"}</Text>
                    <Text strong>{"Provided Email: " + email}</Text>
                </div>,
        });
    };

    return (
        
        <div>
            <div hidden={!payingParticipants} className={"PidInput"}>
                <Text>Please enter your Prolific email address (Prolific_ID@email.prolific.com):</Text>
                <Search
                    type="email"
                    
                    onSearch={(e) => { 
                        if (e !== null && e !== "") {
                            if (validator.isEmail(e)){
                                e = e.toLowerCase();

                                if (e.length !== 43 || !e.endsWith("@email.prolific.com")) {
                                    openEmailRejected(e);
                                } else {
                                    FetchFromBackend('donations/email/' + md5(e),
                                    ()=>{},
                                    () => {
                                        ErrorConnectionFailed();
                                    },
                                    setNumberDonations)
                                    setEmailIdentifierLocal(e);
                                    openNotificationEmailSet(e);
                                }
                            }
                            else{
                                if(emailIdentifierLocal===""){
                                    openEmailRejected(e);
                                }
                            }
                        
                    }}}
                    enterButton="Set"
                    placeholder={emailIdentifierLocal}/>
            </div>
            <div className="PlatformSelectContainer">
                
                {/* ChatGPT */}
                <Button
                    disabled={emailIdentifierLocal === ""}
                    className="PlatformSelectButton"
                    onClick={() => { onClick("chatgpt") }}
                >
                    <div>
                    <Text
                        className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}
                    >
                        Donate your {''} <strong>ChatGPT</strong> data
                    </Text>
                    </div>
                    <div className="PlatformSelectImageWrapper">
                    <img
                        className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"}
                        src={`${process.env.PUBLIC_URL}/Images/ChatGPTLogo.png`}
                        alt="ChatGPT"
                    />
                    </div>
                </Button>
                
                
                {/* Gemini */}
                <Button
                    disabled={emailIdentifierLocal === ""}
                    className="PlatformSelectButton"
                    onClick={() => { onClick("gemini") }}
                >
                    <div>
                    <Text
                        className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}
                    >
                        Donate your {''} <strong>Gemini</strong> data
                    </Text>
                    </div>
                    <div className="PlatformSelectImageWrapper">
                    <img
                        className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"}
                        src={`${process.env.PUBLIC_URL}/Images/GeminiLogo.svg`}
                        alt="Gemini"
                    />
                    </div>
                </Button>
                

                {/* Claude */}
                <Button
                    disabled={emailIdentifierLocal === ""}
                    className="PlatformSelectButton"
                    onClick={() => { onClick("claude") }}
                >
                    <div>
                    <Text
                        className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}
                    >
                        Donate your {''} <strong>Claude</strong> data
                    </Text>
                    </div>
                    <div className="PlatformSelectImageWrapper">
                    <img
                        className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"}
                        src={`${process.env.PUBLIC_URL}/Images/ClaudeLogo.svg`}
                        alt="Claude"
                    />
                    </div>
                </Button>
                

                {/* DeepSeek */}
                <Button
                    disabled={emailIdentifierLocal === ""}
                    className="PlatformSelectButton"
                    onClick={() => { onClick("deepseek") }}
                >
                    <div>
                    <Text
                        className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}
                    >
                        Donate your {''} <strong>DeepSeek</strong> data
                    </Text>
                    </div>
                    <div className="PlatformSelectImageWrapper">
                    <img
                        className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"}
                        src={`${process.env.PUBLIC_URL}/Images/DeepSeekLogo.svg`}
                        alt="DeepSeek"
                    />
                    </div>
                </Button>

                
                
                {/* Mistral */}
                <Button
                    disabled={emailIdentifierLocal === ""}
                    className="PlatformSelectButton"
                    onClick={() => { onClick("mistral") }}
                >
                    <div>
                    <Text
                        className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}
                    >
                        Donate your {''} <strong>Mistral</strong> data
                    </Text>
                    </div>
                    <div className="PlatformSelectImageWrapper">
                    <img
                        className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"}
                        src={`${process.env.PUBLIC_URL}/Images/MistralLogo.svg`}
                        alt="Mistral"
                    />
                    </div>
                </Button>
                

                {/* Grok */}
                <Button
                    disabled={emailIdentifierLocal === ""}
                    className="PlatformSelectButton"
                    onClick={() => { onClick("grok") }}
                >
                    <div>
                    <Text
                        className={useMobileVersion ? "PlatformSelectTextMobile" : "PlatformSelectText"}
                    >
                        Donate your {''} <strong>Grok</strong> (grok.com)
                        <br/>
                        data
                    </Text>
                    </div>
                    <div className="PlatformSelectImageWrapper">
                    <img
                        className={useMobileVersion ? "PlatformSelectImageMobile" : "PlatformSelectImage"}
                        src={`${process.env.PUBLIC_URL}/Images/GrokLogo.svg`}
                        alt="Grok"
                    />
                    </div>
                </Button>

                </div>
        </div>
    )
};

export default PickerPlatform;
